import Header from 'modules/header/wholesaler/main';
import HotAuctionAdds from 'modules/hotAuctionAdds';

import React from 'react';
import {useLocation} from 'react-router';

const HotActionAddsContainer = () => {
  const {state} = useLocation();

  return (
    <div className="w-full h-full">
      <Header title={state.title} />
      <HotAuctionAdds app="farm" />
    </div>
  );
};

export default HotActionAddsContainer;
